import { getIn } from "formik";

import { Calendar } from "react-multi-date-picker";
import { useEffect, useState } from "react";
import { format } from "date-fns";
import CalendarIcon from "../../icons/calendarIcon";
import { useRef } from "react";

const DateInput = ({
  placeholder,
  name,
  disabled,
  formik,
  label,
  noPast,
  max,
  min,
  dateFormat,
}) => {
  const [date, setDate] = useState("");
  const [open, setOpen] = useState(false);
  const calendarRef = useRef(null);

  const handleDateChange = (selectedDate) => {
    const { year, month, day } = selectedDate;
    const newDate = format(
      new Date(year, month.index, day),
      dateFormat || "yyyy/MM/dd"
    );

    setDate(newDate);

    if (formik) {
      formik.setFieldValue(name, newDate);
    }
    setOpen(false);
  };

  const handleClickOutside = (event) => {
    if (calendarRef.current && !calendarRef.current.contains(event.target)) {
      setOpen(false);
    }
  };
  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);
  const required = Object.keys(formik.initialValues).some((key) => key === name);
  const nestedError = getIn(formik.errors, name);

  const nestedTouched = getIn(formik.touched, name);
  return (
    <div className="relative w-full dark:text-white">
      {label && (
        <label className="block mb-1 font-semibold capitalize text-primary">
          {label} {required && <span className="text-mainRed">*</span>}
        </label>
      )}

      <div className="border-primary relative border  rounded-[12px]  gap-1 px-2 bg-sideBar">
        <div
          onClick={() => setOpen(true)}
          className="flex items-center justify-between "
        >
          <input
            type={"text"}
            name={name}
            readOnly
            placeholder={placeholder}
            onBlur={formik && formik.handleBlur}
            value={(formik && formik.getFieldMeta(name)?.value) || ""}
            disabled={disabled}
            className="flex-1 w-full px-2 py-2 bg-transparent h-14 focus-visible:outline-none"
            autoComplete="off"
          />
          <CalendarIcon />
        </div>
        {!disabled && nestedError && nestedTouched && (
          <span className="text-[12px] text-mainRed absolute bottom-[-18px]">
            {nestedError}
          </span>
        )}
        {open && (
          <div
            ref={calendarRef}
            className="absolute z-10 -translate-x-1/2 top-[110%] left-1/2"
          >
            <Calendar
              onChange={handleDateChange}
              value={date}
              minDate={noPast ? new Date() : min ? min : null}
              maxDate={max ? max : null}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default DateInput;
